import React from "react";

import Title from "../../../atoms/proc-management/title";
import { RBACHidden } from "../../../helpers/rbac/rbac";
import { PrimaryButton, TextField } from "@graffer-inc/console-design-kit";
import {
  isShortcut,
  ShortcutDetail,
} from "../../../../application/domain/ttzk-portal";

import {
  ShortcutValidationErrors,
  ShortcutValidator,
} from "../../../../application/domain/ttzk-portal/util/shortcut-validation";
import { useAuthContextV2 } from "../../../../auth-state";

type Props = {
  shortcut: ShortcutDetail;
  onSave: () => void;
  onChange: (shortcut: ShortcutDetail) => void;
  onFileAttached: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
  setOrganization: (id: string) => void;
  isUpdating: boolean;
};

export const ShortcutForm: React.FC<Props> = ({
  shortcut,
  onSave,
  onChange,
  // onFileAttached,
  setOrganization,
  isUpdating,
}) => {
  const { auth } = useAuthContextV2();
  const orgId = auth.data?.orgId;

  React.useEffect(() => {
    if (typeof orgId === "string") {
      setOrganization(orgId);
    }
  }, [orgId, setOrganization]);

  const isUpdate = isShortcut(shortcut);
  const title = isUpdate
    ? `ショートカット編集: ${shortcut.name}`
    : "ショートカット新規作成";
  return (
    <>
      <div>
        <Title text={title} />
        <RBACHidden
          requirePermissions={
            isUpdate
              ? "ttzk_portal.shortcuts.update"
              : "ttzk_portal.shortcuts.create"
          }
        >
          <hr className="my-3" />
          <div>
            <div className="is-pulled-right">
              <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                <PrimaryButton
                  text={"現在の内容を保存する"}
                  onClick={() => onSave()}
                  disabled={!ShortcutValidator.isValid(shortcut)}
                />
              </div>
            </div>
            <div>
              <section className="mb-5">
                <TextField
                  label={"名前"}
                  description="住まい・引っ越し"
                  placeholder=""
                  onChange={(e) => {
                    onChange({
                      ...shortcut,
                      name: e.target.value,
                    });
                  }}
                  value={shortcut.name}
                  errorMessages={
                    ShortcutValidator.name(shortcut.name)
                      ? []
                      : ShortcutValidationErrors.name
                  }
                  required={true}
                />
              </section>
              <section className="mb-5">
                <TextField
                  label={"説明"}
                  description="例）〇〇市の運営する市営住宅や住居や土地に関わる税金、引越しに関する手続きなどのご案内です。"
                  placeholder=""
                  onChange={(e) => {
                    onChange({
                      ...shortcut,
                      description: e.target.value,
                    });
                  }}
                  value={shortcut.description}
                  errorMessages={
                    ShortcutValidator.description(shortcut.description)
                      ? []
                      : ShortcutValidationErrors.description
                  }
                  required={true}
                />
              </section>
              <section className="mb-5">
                <TextField
                  label={"表示順"}
                  description="例): 1"
                  placeholder=""
                  onChange={(e) => {
                    onChange({
                      ...shortcut,
                      priority: parseInt(e.target.value, 10),
                    });
                  }}
                  value={shortcut.priority ? String(shortcut.priority) : ""}
                  errorMessages={
                    ShortcutValidator.priority(
                      shortcut.priority ? String(shortcut.priority) : "",
                    )
                      ? []
                      : ShortcutValidationErrors.priority
                  }
                  required={true}
                />
              </section>
              <section className="mb-5">
                <TextField
                  disabled={isUpdating}
                  label={"URL"}
                  description="https://example.com/"
                  placeholder="https://example.com/"
                  onChange={(e) => {
                    onChange({
                      ...shortcut,
                      url: e.target.value,
                    });
                  }}
                  value={shortcut.url}
                  errorMessages={
                    ShortcutValidator.url(shortcut.url)
                      ? []
                      : ShortcutValidationErrors.url
                  }
                  required={true}
                />
              </section>
              <section className="mb-5">
                <TextField
                  label={"画像URL"}
                  description="https://example.com/"
                  placeholder="https://example.com/"
                  onChange={(e) => {
                    onChange({
                      ...shortcut,
                      imageUrl: e.target.value,
                    });
                  }}
                  value={shortcut.imageUrl}
                  errorMessages={
                    ShortcutValidator.imageUrl(shortcut.imageUrl)
                      ? []
                      : ShortcutValidationErrors.imageUrl
                  }
                  required={true}
                />
              </section>
            </div>
          </div>
        </RBACHidden>
      </div>
    </>
  );
};

export default ShortcutForm;
